import axios from "axios";


export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 20000,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token && config.url?.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAdminRequest = error.config?.url?.startsWith("/admin");
    const isLoginRequest = error.config?.url === "/admin/login";
    if (error.response?.status === 401 && isAdminRequest && !isLoginRequest) {
      localStorage.removeItem("admin_token");
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.assign("/admin/login?reason=session-expired");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
